import { render, staticRenderFns } from "./ExtendedDataEditor.vue?vue&type=template&id=c8dbd8b4&"
import script from "./ExtendedDataEditor.vue?vue&type=script&lang=ts&"
export * from "./ExtendedDataEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports